import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from '../Projects/ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { achivements } from '../../data/constants'

const Achivements = ({openModal,setOpenModal}) => {
    const [toggle, setToggle] = useState('achivements');
    return (
      <Container id="achivements">
        <Wrapper>
          <Title>Places I have stood out!</Title>
          <Desc>
          </Desc>
          <CardContainer>
            {/* {toggle === 'achivements' && achivements
              .map((project) => (
                <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
              ))} */}
            {achivements
              .filter((item) => item.category == toggle)
              .map((project) => (
                <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
              ))}
          </CardContainer>
        </Wrapper>
      </Container>
    )
}

export default Achivements